import createTypeDecorator from '../decorators/createTypeDecorator'

export const ID = Symbol("schemer.types.ID")

export const id = createTypeDecorator(ID, {
  formatDisplay: v => v,
  input: false,
  table: {
    width: 50,
    forceSticky: true
  }
})
